//import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import type { ApplicationConfig } from '@angular/core';
import { provideZonelessChangeDetection, ErrorHandler } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
// // // import { authInterceptor } from './shared/auth.interceptor';
import type { MsalGuardConfiguration, MsalInterceptorConfiguration} from '@azure/msal-angular';
import { MSAL_INSTANCE, MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalInterceptor, MsalGuard, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import type { IPublicClientApplication} from '@azure/msal-browser';
import { PublicClientApplication, InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { infiniteLoopGuardInterceptor } from './shared/infinite-loop-guard.interceptor';
import { appInsightsHttpInterceptor } from './shared/AppInsights/app-insights-http.interceptor';
import { forbiddenInterceptor } from './shared/forbidden.interceptor';
import { AppInsightsErrorHandler } from './shared/AppInsights/app-insights-error-handler';
import { AppInsightsService } from './shared/AppInsights/app-insights.service';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

function msalInstanceFactory(): IPublicClientApplication {
  const msalInstance =  new PublicClientApplication({
    auth: {
      clientId: `${environment.msalClientId}`,
      authority: `https://login.microsoftonline.com/${environment.msalTenantId}`,
      redirectUri:  environment.redirectUri,
      postLogoutRedirectUri: '/login'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false
    },
        system: {
            allowNativeBroker: false, // Disables native brokering support
        }
  });
  
  // Initialize the instance
  msalInstance.initialize();
  
  return msalInstance;
}

function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    // authRequest: {
    //   scopes: ['User.Read']
    // }
  };
}

// function initializeMsalFactory(instance: IPublicClientApplication) {
//   return async () => await instance.initialize();
// }

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set(`${environment.apiBaseUrl}/api/*`,environment.msalRequestScopes); 

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}


export const appConfig: ApplicationConfig = {
  providers: [
  // Include functional interceptors first (runs before DI interceptors)
  provideHttpClient(
    withInterceptors([forbiddenInterceptor, infiniteLoopGuardInterceptor, appInsightsHttpInterceptor]),
    withInterceptorsFromDi()
  ),
    //provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
  { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
  { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
  { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  // Application Insights
  AppInsightsService,
  { provide: ErrorHandler, useClass: AppInsightsErrorHandler },
    provideZonelessChangeDetection(),
    provideAnimations(),
    provideRouter(routes)
  ]
};
